import React from "react";
import AppointmentList from "./../../../components/cases/appointment/AppointmentList";
import { Box, Grid } from "@mui/material";

const AppointmentListPage = () => {
  return (
    <div>
      <Box className="family-tree-main-container">
        <Grid container spacing={5} className="balance-of-assets">
          <Grid item xl={1} lg={1} sm={12} xs={12} />
          <Grid item xl={2} lg={2} sm={12} xs={12}></Grid>
          <Grid item xl={9} lg={9} sm={12} xs={12}>
            <AppointmentList />
          </Grid>
        </Grid>
      </Box>
    </div>
  );
};

export default AppointmentListPage;
